import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { CerebroTextButton } from '../../shared/components';
import { useApi } from '../../shared/context';
import { QueryKeys } from '../../shared/hooks';
import { DataRoomTeaserFile } from '../../shared/models';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { getResponseData } from '../../shared/utils/axios';

interface RemoveTeaserFileDialogProps {
	dataRoomGuid: string | undefined;
	file: DataRoomTeaserFile | null;
	close: () => void;
}

export const RemoveTeaserFileDialog: React.FC<RemoveTeaserFileDialogProps> = ({ dataRoomGuid, file, close }) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onRemoveConfirmation = () => {
		if (file !== null) removeTeaserFile(file);
	};

	const { mutate: removeTeaserFile } = useMutation<DataRoomTeaserFile, unknown, DataRoomTeaserFile>(
		teaserFileToDelete =>
			getResponseData(
				api.delete<DataRoomTeaserFile>(
					CerebroApiEndpoints.Teasers.FileDelete(dataRoomGuid, teaserFileToDelete.guid)
				)
			),
		{
			onMutate: () => {
				close();
			},
			onSuccess: (_data, deletedTeaserFile) => {
				client.invalidateQueries(QueryKeys.DataRoom.Root(dataRoomGuid));
				snackbar.enqueueSnackbar('File Deleted.', { variant: 'success' });

				close();
			},
			onError: () => {
				client.invalidateQueries(QueryKeys.DataRoom.Root(dataRoomGuid));
				snackbar.enqueueSnackbar('There was a problem deleting the file.', { variant: 'error' });
			},
		}
	);

	return (
		<Dialog open={file !== null} onClose={close}>
			<DialogTitle>Confirm Delete</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Are you sure you want to delete this teaser file attachment: {file?.title}?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onRemoveConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
